import { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { doc, getDoc, getFirestore } from 'firebase/firestore';

// Grupos del usuario que ha entrado (users/{uid}.waGroups: admin, comercial,
// operaciones). Es la MISMA lista que reparte las bandejas de WhatsApp.
//
// Hay que mirar los grupos y no el rol: en el CRM casi todo el equipo tiene
// role 'admin', así que el rol no distingue a un comercial de Operaciones.
//
// `null` mientras no se sabe todavía: quien lo use debe esperar a tener la
// respuesta antes de enseñar nada reservado.
export const useWaGroups = () => {
  const [groups, setGroups] = useState(null);

  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const user = getAuth().currentUser;
        if (!user) { if (vivo) setGroups([]); return; }
        const snap = await getDoc(doc(getFirestore(), 'users', user.uid));
        const data = snap.exists() ? snap.data() : {};
        if (vivo) setGroups(Array.isArray(data.waGroups) ? data.waGroups : []);
      } catch {
        // Si no se puede saber, se asume lo mínimo: no enseñar de más.
        if (vivo) setGroups([]);
      }
    })();
    return () => { vivo = false; };
  }, []);

  return groups;
};

/** Operaciones y dirección (André, Diego, ZY). No los comerciales. */
export const esOperaciones = (groups) =>
  Array.isArray(groups) && (groups.includes('admin') || groups.includes('operaciones'));
